import { render, staticRenderFns } from "./AddNewUserToFarm.vue?vue&type=template&id=5e06c733&scoped=true"
import script from "./AddNewUserToFarm.vue?vue&type=script&lang=js"
export * from "./AddNewUserToFarm.vue?vue&type=script&lang=js"
import style0 from "./AddNewUserToFarm.vue?vue&type=style&index=0&id=5e06c733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06c733",
  null
  
)

export default component.exports